module.exports = __webpack_public_path__ + "/content/skins/rivian/css//search-theme-variables.css";